﻿import {getEqualityComparer, NamedValue} from "@2d-front-monorepo/core";
import { useMemo } from "react";

export function useSelectedItem<TValue>(items: NamedValue<TValue>[], value: TValue): string {
	return useMemo(() => {
		if (value == null) {
			return "";
		}

		const comparer = getEqualityComparer(value);
		const idx = items.findIndex(x => comparer(value, x.value!));

		if (idx === -1) {
			return "";
		}

		return idx.toString();
	}, [value, items]);
}
